import { connect } from "react-redux";

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
 import { FaFutbol, FaTv } from 'react-icons/fa';
import { GiStopwatch, GiGamepad } from 'react-icons/gi';
import { MdOutlineCasino } from 'react-icons/md';
import { HiOutlineTicket } from "react-icons/hi2";
import '../../../assets/css/casinoicons.css';
import { SiteFeatures } from 'config/siteFeatures';

const QuickAccess = (props) => {
  const { permissions } = props;
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('sports');

  const sportsItems = [
    {
      id: 1,
      title: t("QUICK_ACCESS_LIVE_TABLES"),
      icon: GiStopwatch,
      path: "/sports/live",
      className: "sportLiveIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.SPORTS_ACCESS?.Value)
    },
    {
      id: 2,
      title: t("QUICK_ACCESS_SPORTS_BETTING"),
      icon: FaFutbol,
      path: "/sports",
      className: "sportIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.SPORTS_ACCESS?.Value)
    }
    ,
    {
      id: 3,
      title: t("TITLE_MYBETS"),
      icon: HiOutlineTicket,
      path: "/my-account/coupons",
      className: "ticketIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.SPORTS_ACCESS?.Value)
    }
  ];

  const casinoItems = [
    {
      id: 1,
      title: t("TITLE_LIVECASINO"),
      icon: MdOutlineCasino,
      path: "/live-casino",
      className: "liveIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.LIVECASINO_ACCESS?.Value)
    },
    {
      id: 2,
      title: t("TITLE_CASINO"),
      icon: MdOutlineCasino,
      path: "/casino",
      className: "slotIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.CASINO_ACCESS?.Value)
    },
   
    {
      id: 5,
      title: 'Keno',
      icon: FaTv,
      path: "/tv-games",
      className: "kenoIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.TVGAMES_ACCESS?.Value)
    },
    {
      id: 3,
      title: t("TITLE_GAMES"),
      icon: GiGamepad,
      path: "/games",
      className: "gamesIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.GAMES_ACCESS?.Value)
    },
    {
      id: 4,
      title: t("TITLE_VIRTUAL"),
      icon: GiGamepad,
      path: "/virtual",
      className: "virtualIcon",
      isActive: (!SiteFeatures.CLOSED_SYSTEM || permissions?.VIRTUAL_ACCESS?.Value)
    }
  ];

  const currentItems = activeTab === 'sports' ? sportsItems : casinoItems;

  return (
    <div className="mb-6 bg-secondary-700/40 lg:rounded-lg max-w-screen-lg mx-auto">
      {/* Tab Menu */}
      <div className="flex items-center border-b border-gray-600">
        <button
          onClick={() => setActiveTab('sports')}
          className={`flex-1 px-4 py-3 text-center relative ${activeTab === 'sports'
              ? 'text-white'
              : 'text-gray-400'
            }`}
        >
          <span className="font-semibold">{t("TITLE_SPORTS")}</span>
          {activeTab === 'sports' && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-yellow-400"></div>
          )}
        </button>
        <div className="w-px h-6 bg-gray-600"></div>
        <button
          onClick={() => setActiveTab('casino')}
          className={`flex-1 px-4 py-3 text-center relative ${activeTab === 'casino'
              ? 'text-white'
              : 'text-gray-400'
            }`}
        >
          <span className="font-semibold">{t("TITLE_CASINO")}</span>
          {activeTab === 'casino' && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-yellow-400"></div>
          )}
        </button>
      </div>

      {/* Grid Menu */}
      <div className="px-2 py-4">
        <div className="grid grid-cols-2 gap-2">
          {currentItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <Link
                key={item.id}
                to={item.isActive ? item.path : '/'}
                className="block "
                style={{
                  opacity: item.isActive ? '1' : '.45',
                  cursor: item.isActive ? 'pointer' : 'not-allowed',
                }}
              >
                <div className="bg-secondary-400/90 rounded-md p-6 relative overflow-hidden hover:bg-secondary-500 transition-all duration-300 border border-gray-700 h-[180px] flex items-center justify-center">
                 {
                  /*
                  <IconComponent
                    className="text-[#0f0] absolute left-0 top-0 opacity-70"
                    size={110}
                    style={{ transform: 'translate(-10px, -10px)' }}
                  />
                  */
                 } 
                 <div className={`${item.className} customIcon`}></div>
                 <h4 className="text-white text-lg font-semibold text-center relative z-10 drop-shadow-xl before:blur-xl before:w-full before:h-full before:absolute before:top-0 before:left-0 before:bg-secondary-500/40 before:opacity-50">{item.title}</h4>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, permissions } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    permissions,
  };
};

export default connect(mapStateToProps)(QuickAccess);
